/**
 * 图片占位链接配置
 * 在实际项目中，这些链接应该替换为真实的图片资源
 */

export const IMAGES = {
  // Logo图片
  logo: 'http://localhost:3000/api/images/1747100616927_92ea8f2c_phonelogo.png',
  
  // 横幅图片
  banner1: '/images/1.jpg',
  banner2: 'http://www.gzhr.org.cn/api/images/view/1748226323170-751511821.jpg?token=3534234b88684a90284495f8ac2b7fff9cb7c7e691032e34e3df2b277f9451bf',
  banner3: '/images/3.jpg',
  banner4: '/images/4.jpg',
  banner5:'images/s1_i2.png',
  
  // 二维码图片
  qrcode: require('@/assets/images/gongzhonghao.jpg'),
  
  // 其他图标
  icons: {
    wechat: 'https://dummyimage.com/18x18/2d8cf0/ffffff&text=W',
    weibo: 'images/邮箱.png',
    qq: 'https://dummyimage.com/18x18/2d8cf0/ffffff&text=Q',
    location: 'images/定位.png',
    phone: 'images/电话.png',
    email: 'images/邮箱.png',
    notice: 'https://dummyimage.com/18x18/2d8cf0/ffffff&text=N',
    
    // 功能图标
    research: 'https://dummyimage.com/30x30/2d8cf0/ffffff&text=R',
    policy: 'https://dummyimage.com/30x30/2d8cf0/ffffff&text=P',
    training: 'https://dummyimage.com/30x30/2d8cf0/ffffff&text=T',
    service: 'https://dummyimage.com/30x30/2d8cf0/ffffff&text=S',
    certification: 'https://dummyimage.com/24x24/2d8cf0/ffffff&text=C'
  },
  
  // 培训课程图片
  courses: {
    systemProjectManager: 'https://dummyimage.com/300x180/1a53a3/ffffff&text=系统项目集成管理师',
    healthManager: 'https://dummyimage.com/300x180/3ca353/ffffff&text=健康管理师',
    economistHR: 'https://dummyimage.com/300x180/ec7a07/ffffff&text=经济师(人力)',
    economistBusiness: 'https://dummyimage.com/300x180/d15608/ffffff&text=经济师(工商)',
    hrManager4: 'https://dummyimage.com/300x180/6b4c9a/ffffff&text=人力资源四级',
    hrManager3: 'https://dummyimage.com/300x180/9953a6/ffffff&text=人力资源三级',
    hrManager2: 'https://dummyimage.com/300x180/a7398b/ffffff&text=人力资源二级',
    hrManager1: 'https://dummyimage.com/300x180/e71d60/ffffff&text=人力资源一级'
  }
}; 